import AOS from 'aos';
import { waitLoad } from "../utilities/load";

waitLoad().then(()=>{
    AOS.init({
        disable: ['mobile','phone','tablet']
    })
});